(function(){
  if (window.initCpx) return;
  function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}
  function parseColours(t){var m={};String(t||'').split(/\r?\n/).forEach(function(l){var i=l.lastIndexOf(':');if(i<1)return;var k=l.slice(0,i).trim().toLowerCase(),v=l.slice(i+1).trim();if(k&&v)m[k]=v;});return m;}

  window.initCpx = function(root, D){
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var opts = D.options || [], V = D.variants || [];
    var R = D.roles || {}, RK = R.racket, GP = R.grip, AC = R.acc;
    var ok = function(i){return typeof i === 'number' && i >= 0 && i < opts.length;};
    var col = parseColours(D.colours);
    var hex = function(n){return col[String(n||'').toLowerCase().trim()] || '#C7C7CC';};
    var L = D.labels || {};
    var label = function(i){return L[i] || opts[i];};
    var T = D.text || {};
    var P = D.parts || {};
    var PARTS = (P.racket||0) + (P.grips||0) + (P.protector||0) + (P.keeper||0);
    var DISC = D.duoDiscount || 0;
    var DUO = D.duo && D.duo.variants ? D.duo : null;
    var FREE = D.free || {}, ST = D.stock || null, STOCK_ON = !!D.stockDefault && !!ST;
    // DUOs racket pair option, e.g. "Midnight Black x2" or "Midnight Black + Ice White". -1 while the DUOs product has no such option.
    var DRK = -1;
    if (DUO && DUO.variants[0]){
      var dn = DUO.variants[0].options.length;
      if (typeof DUO.racket === 'number') DRK = DUO.racket;
      else for (var di = 0; di < dn; di++){ if (di !== DUO.grip && di !== DUO.acc){ DRK = di; break; } }
      if (DRK >= dn) DRK = -1;
    }
    var norm = function(x){return String(x==null?'':x).toLowerCase().replace(/\s+/g,' ').trim();};
    function pairOk(val, a, b){
      val = norm(val); a = norm(a); b = norm(b);
      return a === b ? val === a + ' x2' : (val === a + ' + ' + b || val === b + ' + ' + a);
    }
    function duoMatch(){
      if (!S.duo || !DUO) return null;
      var s0 = S.players[0], s1 = S.players[1], g = ok(GP) ? s0[GP] : null, a = ok(AC) ? s0[AC] : null;
      if (DRK >= 0 && !ok(RK)) return null;
      for (var i = 0; i < DUO.variants.length; i++){
        var v = DUO.variants[i];
        if ((DUO.grip < 0 || v.options[DUO.grip] === g) && (DUO.acc < 0 || v.options[DUO.acc] === a) && (DRK < 0 || pairOk(v.options[DRK], s0[RK], s1[RK]))) return v;
      }
      return null;
    }
    function playerDesc(i){
      var s = S.players[i], parts = [];
      if (ok(RK)) parts.push(s[RK] + ' racket');
      if (ok(GP)) parts.push('3 × ' + s[GP] + ' overgrips');
      parts.push('head protector');
      if (ok(AC)) parts.push(s[AC] + ' ' + String(label(AC)).toLowerCase() + (FREE.keeper ? ' (free)' : ''));
      return parts.join(', ');
    }
    var fmt = new Intl.NumberFormat(D.locale || 'en-GB', {style:'currency', currency:D.currency || 'GBP'});
    var money = function(c){return fmt.format(c/100);};
    var q = function(s){return root.querySelector(s);};
    var values = opts.map(function(_,i){var s=[];V.forEach(function(v){if(s.indexOf(v.options[i])<0)s.push(v.options[i]);});return s;});
    var order = [RK, GP, AC].filter(ok); opts.forEach(function(_,i){ if(order.indexOf(i)<0) order.push(i); });
    var find = function(o){for(var k=0;k<V.length;k++){var v=V[k],m=true;for(var i=0;i<o.length;i++){if(v.options[i]!==o[i]){m=false;break;}}if(m)return v;}return null;};
    var avail = V.filter(function(v){return v.available;});
    // grip colour with the most stock for this build; stock is written by Liquid from the overgrip product when the page renders
    function bestGrip(sel, skip){
      if (!STOCK_ON || !ok(GP)) return null;
      var best = null, bq = -1;
      values[GP].forEach(function(val){
        if (skip && skip.indexOf(val) >= 0) return;
        var t = sel.slice(); t[GP] = val; var v = find(t); if (!v || !v.available) return;
        var qn = ST[norm(val)]; if (typeof qn !== 'number') return;
        if (qn > bq){ bq = qn; best = val; }
      });
      return best;
    }
    var explicit = false; try { explicit = new URL(location.href).searchParams.has('variant'); } catch(e){}
    var start = null; V.forEach(function(v){ if(!start && String(v.id)===String(D.initial)) start=v; });
    if (!start || !start.available) start = avail[0] || V[0];
    if (!start) return;
    // open on the grip colour with the most stock, unless the link asked for a specific variant
    if (!explicit){ var bg = bestGrip(start.options); if (bg){ var bt = start.options.slice(); bt[GP] = bg; var bv = find(bt); if (bv && bv.available) start = bv; } }
    var second = start.options.slice();
    if (ok(RK)){
      var alt = avail.filter(function(v){return v.options[RK] !== start.options[RK];})[0];
      if (alt) second = alt.options.slice();
    }
    // player two opens on the next best stocked colour so two packs spread the load
    var bg2 = bestGrip(second, ok(GP) ? [start.options[GP]] : null); if (bg2) second[GP] = bg2;
    var S = {players:[start.options.slice(), second], active:0, duo:!!D.startDuo, busy:false};
    var NAMES = [T.p1 || 'Player one', T.p2 || 'Player two'];
    var n = function(){return S.duo ? 2 : 1;};

    // swatch groups live in the sheet; one summary chip per option sits on the page
    var groups = q('[data-groups]'), chips = q('[data-chips]'), sheet = q('[data-sheet]'), sheetTitle = q('[data-sheet-title]');
    order.forEach(function(oi, step){
      var big = oi === RK;
      var g = document.createElement('div'); g.className = 'cpx__group'; g.dataset.group = oi;
      g.innerHTML = '<div class="cpx__ghead"><span class="cpx__step" aria-hidden="true">'+(step+1)+'</span><span class="cpx__gname">'+esc(label(oi))+'</span><span class="cpx__gval" data-gval="'+oi+'"></span></div><div class="cpx__sws'+(big?' cpx__sws--big':'')+'" role="radiogroup" aria-label="'+esc(label(oi))+'"></div>';
      var wrap = g.lastChild;
      values[oi].forEach(function(val){
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'cpx__sw' + (big ? ' cpx__sw--big' : '');
        b.setAttribute('role','radio'); b.dataset.opt = oi; b.dataset.val = val;
        b.innerHTML = '<span class="cpx__chip" style="--c:'+esc(hex(val))+'"></span>' + (big ? '<span class="cpx__swname">'+esc(val)+'</span>' : '');
        b.addEventListener('click', function(){ choose(oi, val); });
        wrap.appendChild(b);
      });
      groups.appendChild(g);
      var c = document.createElement('button');
      c.type = 'button'; c.className = 'cpx__chipbtn'; c.dataset.chip = oi;
      c.innerHTML = '<i class="cpx__chipdot" data-chipdot="'+oi+'"></i><span class="cpx__chipk">'+esc(label(oi))+'</span><b class="cpx__chipv" data-chipval="'+oi+'"></b><span class="cpx__chipc">'+esc(T.change || 'Change')+'</span>';
      c.addEventListener('click', function(){ openSheet(oi); });
      chips.appendChild(c);
    });
    // doubles toggle: on the page, under the chips
    var duoWrap = q('[data-duo-wrap]');
    duoWrap.innerHTML = '<div class="cpx__ghead cpx__ghead--duo"><span class="cpx__gname">'+esc(T.duoStep || 'Playing doubles?')+'</span></div>'
      + '<button type="button" class="cpx__duo" data-duo aria-pressed="false"><span class="cpx__tick" aria-hidden="true">&#10003;</span><span class="t"><b>'+esc(T.duoName || 'Add a second pack')+'</b><small data-duo-desc>'+esc(T.duoDesc || '')+'</small></span><span class="p" data-duo-price></span></button>';

    var rackets = q('[data-rackets]'), box = q('[data-box]'), stage = q('[data-stage]');
    var tabs = q('[data-tabs]'), sum = q('[data-sum]'), buy = q('[data-buy]'), disc = q('[data-disc]');
    var priceEl = q('[data-price]'), wasEl = q('[data-was]'), saveEl = q('[data-save]'), duoBtn = q('[data-duo]'), duoPrice = q('[data-duo-price]'), duoDesc = q('[data-duo-desc]');
    var stick = q('[data-cpx-stick]'), stickPrice = q('[data-stick-price]'), stickBuy = q('[data-stick-buy]');

    tabs.innerHTML = [0,1].map(function(i){return '<button type="button" class="cpx__tab" data-tab="'+i+'"><b>'+esc(NAMES[i])+'</b><small data-tabsum="'+i+'"></small></button>';}).join('');
    tabs.addEventListener('click', function(e){ var t = e.target.closest('[data-tab]'); if (t){ S.active = +t.dataset.tab; render(false); } });
    duoBtn.addEventListener('click', function(){ S.duo = !S.duo; S.active = S.duo ? 1 : 0; render(true); });

    // sheet open / close
    function openSheet(oi){
      if (!sheet) return;
      sheet.classList.add('is-open'); root.classList.add('is-sheet');
      if (window.innerWidth < 861) document.body.style.overflow = 'hidden';
      groups.querySelectorAll('.cpx__group').forEach(function(g){ g.classList.toggle('is-current', String(g.dataset.group) === String(oi)); });
      if (sheetTitle) sheetTitle.textContent = oi != null ? label(oi) : (sheetTitle.getAttribute('data-default') || sheetTitle.textContent);
      var g = groups.querySelector('.cpx__group[data-group="'+oi+'"]');
      if (g){ var body = g.closest('.cpx__sheet-body'); if (body) body.scrollTop = Math.max(0, g.offsetTop - 8); var on = g.querySelector('.cpx__sw.is-on'); if (on) on.focus({preventScroll:true}); }
    }
    function closeSheet(){
      if (!sheet) return;
      sheet.classList.remove('is-open'); root.classList.remove('is-sheet'); document.body.style.overflow = '';
    }
    if (sheetTitle) sheetTitle.setAttribute('data-default', sheetTitle.textContent);
    root.addEventListener('click', function(e){ if (e.target.closest('[data-sheet-close]')) closeSheet(); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && sheet && sheet.classList.contains('is-open')) closeSheet(); });

    // sticky buy bar: shows whenever the main button is off screen (CSS limits it to phones)
    if (stick && buy && 'IntersectionObserver' in window){
      new IntersectionObserver(function(e){ stick.classList.toggle('is-peek', !e[0].isIntersecting); }, {threshold:0}).observe(buy);
    }
    if (stickBuy) stickBuy.addEventListener('click', function(){ buy.click(); });

    // racket units
    var units = [0,1].map(function(i){
      var u = document.createElement('button'); u.type = 'button'; u.className = 'cpx__unit'; u.tabIndex = -1;
      u.innerHTML = '<div class="cpx__ph"><img alt="" decoding="async"><div class="cpx__tint" hidden></div></div><span class="cpx__tag"></span>';
      u.addEventListener('click', function(){ if (S.duo && S.active !== i){ S.active = i; render(false); } });
      rackets.appendChild(u); return u;
    });

    function heal(p, oi, val){
      var sel = S.players[p]; if (oi != null) sel[oi] = val;
      var v = find(sel); if (v && v.available) return;
      var best = null, bd = 99;
      avail.forEach(function(x){
        if (oi != null && x.options[oi] !== val) return;
        var d = 0; x.options.forEach(function(o,i){ if (o !== sel[i]) d++; });
        if (d < bd){ bd = d; best = x; }
      });
      if (best) S.players[p] = best.options.slice();
    }
    function choose(oi, val){ heal(S.active, oi, val); render(true, S.active); }

    function paint(i, anim){
      var u = units[i], sel = S.players[i];
      u.hidden = i >= n();
      if (u.hidden) return;
      var rk = ok(RK) ? sel[RK] : '', gp = ok(GP) ? sel[GP] : '';
      var key = String(rk).toLowerCase().trim();
      var ph = (D.photos || {})[key] || {};
      var src = ph.img || (D.fallback || {})[key] || '';
      var img = u.querySelector('img'), tint = u.querySelector('.cpx__tint');
      if (src && img.getAttribute('src') !== src){ if (i === 0 && !img.getAttribute('src')){ img.setAttribute('fetchpriority','high'); } img.src = src; }
      img.alt = rk + ' 12K padel racket with ' + gp + ' overgrip';
      if (ph.img && ph.mask){ tint.hidden = false; tint.style.webkitMaskImage = tint.style.maskImage = 'url("'+ph.mask+'")'; tint.style.backgroundColor = hex(gp); }
      else tint.hidden = true;
      u.querySelector('.cpx__tag').textContent = S.duo ? NAMES[i] : '';
      u.classList.toggle('is-active', i === S.active);
      if (anim){ u.classList.add('is-swap'); clearTimeout(u._t); u._t = setTimeout(function(){ u.classList.remove('is-swap'); }, 180); }
    }

    function drawBox(){
      var N = n(), pics = D.pics || {}, h = '';
      var dots = function(idx){ return '<div class="cpx__dots">' + S.players.slice(0,N).map(function(s){ return '<i class="cpx__dot" style="--c:'+esc(hex(s[idx]))+'"></i>'; }).join('') + '</div>'; };
      h += '<div class="cpx__item">' + (ok(GP) ? dots(GP) : '') + '<span>' + (3*N) + ' overgrips</span></div>';
      h += '<div class="cpx__item">' + (pics.prot ? '<img src="'+esc(pics.prot)+'" alt="" loading="lazy">' : '') + '<span>' + N + ' head protector' + (N>1?'s':'') + '</span></div>';
      var kp = pics.keeper || {};
      var keepers = function(){ return '<div class="cpx__dots">' + S.players.slice(0,N).map(function(s){ var u = kp[String(s[AC]).toLowerCase().trim()]; return u ? '<img src="'+esc(u)+'" alt="'+esc(s[AC])+' score keeper" loading="lazy">' : '<i class="cpx__dot" style="--c:'+esc(hex(s[AC]))+'"></i>'; }).join('') + '</div>'; };
      h += '<div class="cpx__item">' + (ok(AC) ? keepers() : '') + '<span>' + N + ' ' + (FREE.keeper ? 'free ' : '') + esc(String(label(AC)).toLowerCase()) + (N>1?'s':'') + '</span></div>';
      box.innerHTML = h;
    }

    function render(anim, which){
      var N = n();
      root.classList.toggle('is-duo', S.duo);
      rackets.classList.toggle('is-duo', S.duo);
      if (S.active >= N) S.active = 0;
      var sel = S.players[S.active];
      root.querySelectorAll('.cpx__sw').forEach(function(b){
        var oi = +b.dataset.opt, val = b.dataset.val, on = sel[oi] === val;
        b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1;
        var t = sel.slice(); t[oi] = val; var tv = find(t);
        var out = !tv || !tv.available;
        // grips and keepers that are sold out for this racket are hidden, not struck through; rackets stay visible
        if (oi === RK){ b.hidden = false; b.classList.toggle('is-out', out); }
        else { b.classList.remove('is-out'); b.hidden = out && !on; }
        b.setAttribute('aria-label', val + (out ? ', sold out in this combination' : ''));
      });
      order.forEach(function(oi){
        var e = root.querySelector('[data-gval="'+oi+'"]'); if (e) e.textContent = sel[oi];
        var cv = root.querySelector('[data-chipval="'+oi+'"]'); if (cv) cv.textContent = sel[oi];
        var cd = root.querySelector('[data-chipdot="'+oi+'"]'); if (cd) cd.style.setProperty('--c', hex(sel[oi]));
      });
      tabs.querySelectorAll('[data-tab]').forEach(function(t,i){
        t.classList.toggle('is-on', i === S.active);
        t.setAttribute('aria-pressed', i === S.active ? 'true' : 'false');
        var s = S.players[i]; t.querySelector('small').textContent = [ok(RK)?s[RK]:'', ok(GP)?s[GP]+' grips':''].filter(Boolean).join(', ');
      });
      units.forEach(function(u,i){ paint(i, anim && (which == null || which === i)); });
      drawBox();

      var vs = S.players.slice(0,N).map(find);
      var allOk = vs.every(function(v){ return v && v.available; });
      var unit = (vs[0] && vs[0].price) || 0;
      var total = vs.reduce(function(a,v){ return a + (v ? v.price : 0); }, 0) - (S.duo ? DISC : 0);
      var dv = duoMatch(); if (dv && dv.available) total = dv.price;
      var was = PARTS * N;
      priceEl.textContent = money(total);
      if (stickPrice) stickPrice.textContent = money(total);
      wasEl.textContent = was > total ? money(was) : '';
      saveEl.textContent = was > total ? 'You save ' + money(was - total) : '';
      duoBtn.setAttribute('aria-pressed', S.duo ? 'true' : 'false');
      // honest doubles maths: second pack price, the two-pack total and the saving against two packs bought one at a time
      var secondPrice = unit - DISC, twoPacks = (dv && dv.available) ? dv.price : unit * 2 - DISC;
      duoPrice.innerHTML = (S.duo ? '' : '+') + money(secondPrice) + '<small>' + esc(S.duo ? 'second pack' : 'second pack') + '</small>';
      if (duoDesc) duoDesc.textContent = (T.duoDesc ? T.duoDesc + ' ' : '') + 'Two packs for ' + money(twoPacks) + (DISC ? ' · save ' + money(unit * 2 - twoPacks) + ' vs two packs' : '');

      var list = function(idx){ return S.players.slice(0,N).map(function(s){ return s[idx]; }).join(', '); };
      var rows = [
        [N + ' × 12K carbon racket' + (ok(RK) ? ' (' + list(RK) + ')' : ''), P.racket * N],
        [(3*N) + ' × overgrip' + (ok(GP) ? ' (' + list(GP) + ')' : ''), P.grips * N],
        [N + ' × head protector', P.protector * N],
        [N + ' × ' + String(label(AC)).toLowerCase() + (ok(AC) ? ' (' + list(AC) + ')' : ''), P.keeper * N, !!FREE.keeper]
      ];
      // the free item keeps its struck value so the saving still adds up, and reads Free instead of a price
      var h = rows.filter(function(r){ return r[1] > 0; }).map(function(r){ return r[2] ? '<div class="cpx__li fr"><span>'+esc(r[0])+'</span><span><s>'+money(r[1])+'</s>Free</span></div>' : '<div class="cpx__li"><span>'+esc(r[0])+'</span><span>'+money(r[1])+'</span></div>'; }).join('');
      if (was > total) h += '<div class="cpx__li sv"><span>You save</span><span>' + money(was - total) + '</span></div>';
      sum.innerHTML = h;

      if (!S.busy){
        buy.disabled = !allOk;
        buy.textContent = allOk ? ((S.duo ? 'Add both packs · ' : 'Add to basket · ') + money(total)) : 'Sold out in this combination';
        if (stickBuy) stickBuy.disabled = !allOk;
      }
      disc.textContent = S.duo ? ((dv && dv.available) ? 'Goes in your bag as one DUOs set. Both builds are listed on your order.' : (DISC ? ('Two Court Packs at ' + money(unit) + ' each. The ' + money(DISC) + ' DUOs saving is applied automatically in your basket.') : '')) : '';

      if (D.updateUrl && vs[0] && window.history && history.replaceState){
        try { var u = new URL(location.href); u.searchParams.set('variant', vs[0].id); history.replaceState(history.state, '', u.toString()); } catch(e){}
      }
    }

    root.addEventListener('keydown', function(e){
      var b = e.target.closest && e.target.closest('.cpx__sw'); if (!b) return;
      var k = {ArrowRight:1, ArrowDown:1, ArrowLeft:-1, ArrowUp:-1}[e.key]; if (!k) return;
      e.preventDefault();
      var list = Array.prototype.slice.call(b.parentNode.children).filter(function(x){ return !x.hidden; }), i = list.indexOf(b);
      var nb = list[(i + k + list.length) % list.length];
      choose(+nb.dataset.opt, nb.dataset.val); nb.focus();
    });

    buy.addEventListener('click', function(){
      var N = n(), vs = S.players.slice(0,N).map(find);
      if (S.busy || !vs.every(function(v){ return v && v.available; })) return;
      var items = vs.map(function(v,i){
        var s = S.players[i], props = {};
        if (S.duo) props['Set'] = NAMES[i];
        if (ok(RK)) props['Racket'] = '1 × 12K carbon, ' + s[RK];
        if (ok(GP)) props['Overgrips'] = '3 × ' + s[GP];
        props['Head protector'] = '1 × clear stick on';
        if (ok(AC)) props[String(label(AC))] = '1 × ' + s[AC] + (FREE.keeper ? ' · Free, ' + money(0) : '');
        return {id:v.id, quantity:1, properties:props};
      });
      var dv = duoMatch();
      if (dv && dv.available){
        var props = {};
        props['Player one'] = playerDesc(0);
        props['Player two'] = playerDesc(1);
        items = [{id: dv.id, quantity: 1, properties: props}];
      }
      S.busy = true; buy.disabled = true; buy.textContent = 'Adding to basket'; if (stickBuy) stickBuy.disabled = true;
      var done = function(){ buy.textContent = 'Added'; setTimeout(function(){ S.busy = false; render(false); }, 1500); };
      if (D.preview){ setTimeout(done, 600); return; }
      var fail = function(){ S.busy = false; buy.disabled = false; if (stickBuy) stickBuy.disabled = false; buy.textContent = 'Could not add. Tap to try again'; };
      if (window.theme && typeof window.theme.addToCart === 'function'){
        window.theme.addToCart(items).then(done).catch(fail); return;
      }
      fetch(D.addUrl || '/cart/add.js', {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items:items})})
        .then(function(r){ if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function(){ location.href = D.cartUrl || '/cart'; })
        .catch(fail);
    });

    function refresh(){
      if (D.preview || !D.productJs) return;
      fetch(D.productJs + (D.productJs.indexOf('?') < 0 ? '?' : '&') + '_=' + Date.now(), {credentials:'same-origin'})
        .then(function(r){ return r.json(); })
        .then(function(p){
          if (!p || !p.variants) return;
          var m = {}, ch = false;
          p.variants.forEach(function(v){ m[v.id] = v; });
          V.forEach(function(v){ var x = m[v.id]; if (x){ if (x.available !== v.available){ v.available = x.available; ch = true; } if (x.price !== v.price){ v.price = x.price; ch = true; } } });
          if (ch){ avail = V.filter(function(v){ return v.available; }); render(false); }
        }).catch(function(){});
    }
    document.addEventListener('visibilitychange', function(){ if (!document.hidden) refresh(); });
    setInterval(refresh, 60000);

    render(false);
  };

  function boot(scope){
    (scope || document).querySelectorAll('[data-cpx]:not([data-ready])').forEach(function(el){
      var s = el.querySelector('script[data-cpx-json]'); if (!s) return;
      try { window.initCpx(el, JSON.parse(s.textContent)); } catch(e){ console.error('Configurator failed to start', e); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ boot(); }); else boot();
  document.addEventListener('shopify:section:load', function(e){ boot(e.target); });
})();
